import { createBrowserRouter, redirect, RouterProvider } from 'react-router';

import PrivateLayout from '@/components/layout/privateLayout';
import {
  BASE_PATHS,
  getLoggedInUserDashboardRoute,
} from '@/constants/route.constant';
import { checkAuthAndRedirect } from '@/helper/auth.helper.ts';
import authRoutes from '@/modules/auth/routes.ts';
import PageNotFound from '@/modules/errors/404';
import { settingsRoutes } from '@/modules/settings/routes.ts';
import { timesheetRoutes } from '@/modules/timesheet/routes.ts';

const router = createBrowserRouter([
  {
    path: '/',
    loader: () => checkAuthAndRedirect('redirect'),
  },
  authRoutes,
  {
    path: BASE_PATHS.DASHBOARD,
    loader: () => checkAuthAndRedirect('authenticated'),
    Component: PrivateLayout,
    children: [
      {
        index: true,
        loader: () => redirect(getLoggedInUserDashboardRoute()),
      },
      ...timesheetRoutes,
      ...settingsRoutes,
      // ...projectChildren,
      // {
      //   path: PROTECTED_ROUTES.DASHBOARD.DEVICES.ROOT,
      //   Component: Devices,
      //   children: [
      //     {
      //       path: 'list',
      //       lazy: async () => {
      //         const mod = await import('@/modules/devices/list');
      //         return { Component: mod.default };
      //       },
      //     },
      //     {
      //       path: 'categories',
      //       lazy: async () => {
      //         const mod = await import('@/modules/devices/categories');
      //         return { Component: mod.default };
      //       },
      //     },
      //     {
      //       path: 'suppliers',
      //       lazy: async () => {
      //         const mod = await import('@/modules/devices/suppliers');
      //         return { Component: mod.default };
      //       },
      //     },
      //     {
      //       path: 'locations',
      //       lazy: async () => {
      //         const mod = await import('@/modules/devices/locations');
      //         return { Component: mod.default };
      //       },
      //     },
      //   ],
      // },
      // {
      //   path: PROTECTED_ROUTES.DASHBOARD.PEOPLES,
      //   Component: PeoplesLayout,
      //   children: [
      //     { index: true, Component: Peoples },
      //     { path: ':id/personal', Component: PersonalDetails },
      //     { path: ':id/job', Component: JobDetails },
      //     { path: ':id/time-off', Component: TimeOffDetails },
      //     { path: ':id/emergency', Component: PeopleDetail },
      //     { path: ':id/documents', Component: PeopleDetail },
      //     { path: ':id/training', Component: PeopleDetail },
      //     { path: ':id/performance', Component: PeopleDetail },
      //   ],
      // },
      {
        path: '*',
        element: <PageNotFound />,
        handle: { isNotFound: true },
      },
    ],
  },
]);

export const RoutesPage = () => {
  return <RouterProvider router={router} />;
};
